module.exports = __webpack_public_path__ + "static/media/floor_tom_6.0965b5cf.png";